import React from "react";
import { Container } from "./styles";

import { Home } from "../Home/Home";
import { TrustedBy } from "../TrustedBy/TrustedBy";

const Portfolio = React.lazy(() => import("../Portfolio/Portfolio").then(m => ({ default: m.Portfolio })));
const Prices = React.lazy(() => import("../Prices/Prices").then(m => ({ default: m.Prices })));
const Contact = React.lazy(() => import("../Contact/Contact").then(m => ({ default: m.Contact })));
const WhoIAm = React.lazy(() => import("../WhoIAm/WhoIAm").then(m => ({ default: m.WhoIAm })));
const Testimonials = React.lazy(() => import("../Testimonials/Testimonials").then(m => ({ default: m.Testimonials })));
const HowItWorks = React.lazy(() => import("../HowItWorks/HowItWorks").then(m => ({ default: m.HowItWorks })));

export function Main() {

  return (
    <Container>
      <Home></Home>
      <TrustedBy />
      <React.Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Portfolio isMain />
        <Testimonials />
        <WhoIAm></WhoIAm>
        <HowItWorks />
        <Prices></Prices>
        <Contact></Contact>
      </React.Suspense>
    </Container>
  );
}
